import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const COLORS = {
  magenta: "#FF00DD",
  orange: "#FF8C00",
  yellow: "#FFD400",
  lime: "#C6F000",
  purple: "#7B1FFF",
};
